/**
 * Chart anchor derived from a symbol's `date_end`.
 *
 * The datafeed reports `date_end` as a day boundary: either "2026-09-02" or
 * "2026-09-02T00:00:00" (midnight of the last day that has M1 bars). Anchor to
 * the END of that UTC day so the initial history request includes the whole
 * last available day. Returns unix seconds, or null when unparsable.
 */
export function toAnchorTs(value: string): number | null {
  const day = value.slice(0, 10)
  const ms = Date.parse(`${day}T23:59:59Z`)
  return Number.isNaN(ms) ? null : Math.floor(ms / 1000)
}
